import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { PurchaseStatus } from '@/components/PPVPopup/PPVPopup'
import { ChannelType, EventType } from '@/types/servicesTypes/configTypes'

export type PpvPopup = {
  event: EventType
  eventChannel?: Nullable<ChannelType>
  prevFocusId: string
}

export type PPVPopupStoreType = {
  boughtEventIds: string[]
  ppvPopup: Nullable<PpvPopup>
  purchaseStatus: Nullable<PurchaseStatus>
  setPpvPopup: (ppvPopup: Nullable<PpvPopup>) => void
  setPurchaseStatus: (purchaseStatus: Nullable<PurchaseStatus>) => void
  addBoughtEventId: (boughtEventIds: string) => void
  removeUpdatedEventIds: (updatedEventIds: string[]) => void
}

export const usePPVPopupStore = create<PPVPopupStoreType>()(
  devtools(
    immer((setState) => ({
      boughtEventIds: [],
      ppvPopup: null,
      purchaseStatus: null,
      setPpvPopup: (ppvPopup: Nullable<PpvPopup>) =>
        setState(
          (state) => {
            state.ppvPopup = ppvPopup
          },
          false,
          `setPpvPopup`,
        ),
      setPurchaseStatus: (purchaseStatus: Nullable<PurchaseStatus>) =>
        setState(
          (state) => {
            state.purchaseStatus = purchaseStatus
          },
          false,
          `setPurchaseStatus`,
        ),
      addBoughtEventId: (boughtEventId) =>
        setState(
          (state) => {
            state.boughtEventIds.push(boughtEventId)
            if (state.ppvPopup?.event) {
              state.ppvPopup.event.userRights = {
                canAccess: true,
                reasons: [{ type: 'Ppv' }],
              }
            }
          },
          false,
          `addBoughtEventId`,
        ),
      removeUpdatedEventIds: (updatedEventIds) => {
        if (updatedEventIds.length) {
          setState(
            (state) => {
              state.boughtEventIds = state.boughtEventIds.filter(
                (id) => !updatedEventIds.includes(id),
              )
            },
            false,
            `removeUpdatedEventIds`,
          )
        }
      },
    })),
    { name: 'ppvPopupStore' },
  ),
)
